import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Navigate, Outlet } from 'react-router-dom'
import AllSetPage from './AllSetPage'
import BedtimeRoutineManagement from './BedtimeRoutineMangement'
import BedtimeRoutinePage from './BedtimeRoutinePage'
import HabitsManagementPage from './HabitsManagementPage'
import HabitsPage from './HabitsPage'
import ImproveSleepPage from './ImproveSeelpPage'
import SleepGoalPage from './SleepGoalPage'
import SleepHoursManagement from './SleepHoursManagement'
import SleepHoursPage from './SleepHoursPage'
import SleepQualityPage from './SleepQualityPage'
import SleepTrackingPage from './SleepTrackingPage'
import StrugglesSoundsPage from './StrugglesSounds'
import WakeUpPage from './WakeUpPage'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="struggles-sounds" replace />,
        index: true,
      },

      {
        action: navigateToNextOnboardingPageAction,
        element: <StrugglesSoundsPage />,
        path: 'struggles-sounds',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HabitsPage />,
        path: 'habits',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HabitsManagementPage />,
        path: 'habits-management',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepQualityPage />,
        path: 'sleep-quality',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepHoursPage />,
        path: 'sleep-hours',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepHoursManagement />,
        path: 'sleep-hours-management',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepGoalPage />,
        path: 'sleep-goal',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BedtimeRoutinePage />,
        path: 'bedtime-routine',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BedtimeRoutinePage />,
        path: 'bedtime-routine',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BedtimeRoutineManagement />,
        path: 'bedtime-routine-management',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ImproveSleepPage />,
        path: 'improve-sleep',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SleepTrackingPage />,
        path: 'sleep-tracking',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <WakeUpPage />,
        path: 'wake-up',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <AllSetPage />,
        path: 'all-set',
      },
    ],
  },
]

export default onboardingRoutes
